import { useFullCartRefetch } from '@utils/useFullCartRefetch'
import { CartType, useRouter } from '@src/routes'
import { CartRequestAction } from '@src/types/graphql-types'

/**
 * This method is used when we clear cart in shopping cart page, and
 * when we delete cart item or clear cart in mimi cart drawer.
 * When we delete cart item or clear cart, we need to refetch specific FullCart
 * to make page refersh.
 * @param cartType
 */
export const useRefetchSpecificFullCart = (cartType) => {
  const router = useRouter()
  const { refetchFullCart } = useFullCartRefetch()
  return () => {
    const cartQueryType = router?.query?.type as CartType | undefined
    switch (cartType) {
      case CartType.BlueCart:
        if (
          cartQueryType === CartType.BlueCart ||
          cartQueryType === CartType.Active
        ) {
          refetchFullCart(CartRequestAction.Bluecartmini)
        }
        return
      case CartType.MarketplaceCart:
        if (
          cartQueryType === CartType.MarketplaceCart ||
          cartQueryType === CartType.Active
        ) {
          refetchFullCart(CartRequestAction.Marketplace)
        }
        return
      default:
        refetchFullCart(CartRequestAction.Mini)
        return
    }
  }
}
